<section class="q-toasts">
  <div class="q-toast" *ngFor="let toast of toasts" id="{{toast.id}}">
    <div class="container">
      <div class="row">
        <div class="col-sm-1 d-flex flex-column justify-content-center" [style.background-color]="toast.color">
          <div class="w-100 d-flex flex-row justify-content-center">
            <i class="fa {{ toast.faIcon }}"></i>
          </div>
        </div>
        <div class="q-toast-desc col-sm-10">{{ toast.title }}</div>
        <div class="col-sm-1  d-flex flex-column justify-content-center">
          <div class="w-100 d-flex flex-row justify-content-center">
            <span class="q-toast-close" (click)="removeToast(toast)">&#43;</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
